import React from 'react';
import { motion } from 'framer-motion';
import { PROFILE } from '../data/profile';
type PageHeaderProps = {
  index: string;
  title: string;
  intro: string;
};
export function PageHeader({
  index,
  title,
  intro
}: PageHeaderProps) {
  return <section className="relative isolate w-full overflow-hidden bg-navy-950" data-id="element-240" data-mp="3rdudkwkuepcq">
      <img src={PROFILE.facade} alt="" aria-hidden="true" className="absolute inset-0 h-full w-full object-cover opacity-25" data-id="element-241" data-mp="3mgu74kk2zkl3" />
      <div aria-hidden="true" className="absolute inset-0" style={{
      backgroundImage: 'linear-gradient(90deg, rgba(6,15,31,0.97) 0%, rgba(6,15,31,0.9) 55%, rgba(6,15,31,0.7) 100%)'
    }} data-id="element-242" data-mp="2tr3rg72swamv" />
      <div className="relative mx-auto max-w-content px-6 pb-16 pt-44 sm:pb-20 sm:pt-48 lg:px-8 xl:pt-56" data-id="element-243" data-mp="33ngjz1mm0ig1">
        <motion.div initial={{
        opacity: 0,
        y: 18
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        ease: [0.22, 1, 0.36, 1]
      }} className="max-w-3xl" data-id="element-244" data-mp="2fxm7wma46xwu">
          <div className="flex items-center gap-3" data-id="element-245" data-mp="2hwvpmsi5c5y6">
            <span className="font-serif text-sm text-gold-400" data-id="element-246" data-mp="2lziag9gegqlv">{index}</span>
            <span className="h-px w-10 bg-gold-500" aria-hidden="true" data-id="element-247" data-mp="2qrjrs9sfd7ir" />
            <span className="text-[11px] font-medium uppercase tracking-widest text-slateink-300" data-id="element-248" data-mp="2qtmjcy9878pl">
              Section {index}
            </span>
          </div>
          <h1 className="mt-6 font-serif text-[34px] leading-[1.1] text-white sm:text-5xl" data-id="element-249" data-mp="1z1fc2ofm18nv">
            {title}
          </h1>
          <p className="mt-6 max-w-2xl text-[15px] leading-relaxed text-slateink-300 sm:text-base" data-id="element-250" data-mp="233s8gm8gvu7z">
            {intro}
          </p>
        </motion.div>
      </div>
    </section>;
}